module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "value": _vm.textValue,
      "label": _vm.schema.label,
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder || ' ',
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "prefix": "$"
    },
    on: {
      "change": _vm.change,
      "focus": function($event) {
        return _vm.$emit('focus', $event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-406f2a23"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/blocks/CurrencyControl.vue
// module id = 2524
// module chunks = 1